import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { commonErrorResponses, requiredPayloadEnvelope } from '../envelope.js';
/** admin 콘솔에 노출하는 OAuth IdP 설정 한 행이다. clientSecret 원문은 내려주지 않는다. */
const oauthProviderAdminSchema = z.object({
    /** IdP 식별자다. 예: `google`, `twitch`, `chzzk`. */
    provider: z.string(),
    /** false면 해당 IdP 로그인·연동을 막는다. */
    enabled: z.boolean(),
    /** OAuth client id다. 미설정이면 null이다. */
    clientId: z.string().nullable(),
    /** client secret이 DB에 저장돼 있으면 true다. 값 자체는 응답에 없다. */
    hasSecret: z.boolean(),
    /** secret을 마지막으로 교체한 시각이다. 없으면 null이다. */
    rotatedAt: z.union([z.string(), z.null()]),
    /** 설정 행 마지막 수정 시각이다. */
    updatedAt: z.union([z.string(), z.date()]),
    /** 이 IdP에 등록해야 하는 redirect URI다. admin 콘솔에서 복사한다. */
    redirectUri: z.string(),
});
const c = initContract();
/** admin-api — OAuth IdP 활성화·client id·secret 로테이션. `super_admin` 시스템 라우트다. */
export const adminOAuthProvidersContract = c.router({
    /** 등록된 OAuth IdP 설정 목록을 조회한다. */
    list: {
        method: 'GET',
        path: '/system/oauth-providers',
        responses: {
            200: requiredPayloadEnvelope(z.array(oauthProviderAdminSchema)),
            ...commonErrorResponses,
        },
    },
    /** IdP 활성 여부·client id를 갱신한다. secret은 rotateSecret로만 바꾼다. */
    update: {
        method: 'PATCH',
        path: '/system/oauth-providers/:provider',
        pathParams: z.object({
            /** 갱신할 IdP 식별자다. */
            provider: z.string(),
        }),
        body: z.object({
            /** 활성 on/off다. */
            enabled: z.boolean().optional(),
            /** OAuth client id다. null이면 비운다. */
            clientId: z.string().nullable().optional(),
        }),
        responses: {
            200: requiredPayloadEnvelope(oauthProviderAdminSchema),
            ...commonErrorResponses,
        },
    },
    /** client secret을 교체한다. 요청 본문의 값으로 덮어쓴다. */
    rotateSecret: {
        method: 'POST',
        path: '/system/oauth-providers/:provider/rotate-secret',
        pathParams: z.object({
            /** secret을 바꿀 IdP 식별자다. */
            provider: z.string(),
        }),
        body: z.object({
            /** 새 OAuth client secret 평문이다. */
            clientSecret: z.string().optional(),
        }),
        responses: {
            200: requiredPayloadEnvelope(oauthProviderAdminSchema),
            ...commonErrorResponses,
        },
    },
});
export { oauthProviderAdminSchema };
//# sourceMappingURL=oauth-providers.contract.js.map